import { render, staticRenderFns } from "./dinnercarddetail.vue?vue&type=template&id=4b34df98&scoped=true&"
import script from "./dinnercarddetail.vue?vue&type=script&lang=js&"
export * from "./dinnercarddetail.vue?vue&type=script&lang=js&"
import style0 from "./dinnercarddetail.vue?vue&type=style&index=0&id=4b34df98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b34df98",
  null
  
)

export default component.exports